export default __webpack_public_path__ + "static/342-6f9caab3d79f1a7386f4a31f59ffd329.gif";